import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  VideoComponent,
  PlainVideoComponent,
  CanvasedVideoComponent,
  AudioComponent
} from "./components";

@NgModule({
  imports: [CommonModule],
  declarations: [
    VideoComponent,
    PlainVideoComponent,
    CanvasedVideoComponent,
    AudioComponent
  ],
  exports: [VideoComponent, AudioComponent]
})
export class YoumAngularLibModule {}
